import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ApplicationLauncherService {
  constructor(private http: HttpClient) {}

  getSsoCode(endpoint: string, codeField = 'short_code'): Observable<string> {
    const ssoUrl = `${environment.apiBaseUrl.replace(/\/+$/, '')}/${endpoint.replace(/^\/+/, '')}`;

    return this.http.get<any>(ssoUrl).pipe(
      map((response) => {
        const responseData = response?.data ?? response;
        const code = this.getNestedValue(responseData, codeField)
          ?? this.getNestedValue(response, codeField);

        if (code === undefined || code === null || String(code).trim() === '') {
          throw new Error(`SSO response does not contain ${codeField}`);
        }

        return String(code);
      }),
    );
  }

  private getNestedValue(source: any, path: string): any {
    return path.split('.').reduce(
      (value: any, key: string) => value?.[key],
      source,
    );
  }
}
